<template>
    <div class="box">
        <Titlebar
                :title="'标记货柜'"/>
        <video id="video" class="qrcode-video"/>
        <div class="note">
            请把下方的编号写到柜子上，方便快速找到出问题的柜子
        </div>
        <div class="box-tag">
            {{ boxTag }}
        </div>
        <video-device-error placeholder="输入主控码" v-model="visible" prefix="https://machine.goldbox.vip/"
                            @submit="onDecode"/>
    </div>
</template>

<script>


    import Titlebar from "./Titlebar.vue"
    import videoDeviceError from "./videoDeviceError";

    import {isBoxNumber, parseBoxNumber} from "../util/utils.js"

    import {scanQrCode} from '../util/qrcode.js';

    import message from "ant-design-vue/lib/message";

    export default {
        name: 'MarkCupboard',
        data() {
            return {
                boxTag: "",
                visible: false
            }
        },
        props: {},
        components: {
            Titlebar,
            videoDeviceError
        },
        mounted() {
            scanQrCode("video", this.onDecode, () => {
                this.visible = true;
            })
        },
        methods: {
            onDecode(boxNumber) {

                if (isBoxNumber(boxNumber)) {
                    var number = parseBoxNumber(boxNumber)

                    var url = process.env.VUE_APP_API_SERVER + '/box/' + number + "/tag"
                    var accessToken = localStorage.getItem('accessToken')

                    var that = this
                    fetch(url, {
                        method: "POST",
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Access-Token': accessToken
                        })
                    }).then(res => {
                        if (!res.ok) {
                            throw res
                        }
                        return res.json()
                    }).catch(error => {
                        sessionStorage.setItem("fetchTag", "failed")
                        sessionStorage.setItem("fetchTagFailedReason", error)
                        that.$router.go(-1)
                    }).then(response => {
                        if (!response.Tag || response.Tag == 0) {
                            sessionStorage.setItem("fetchTag", "failed")
                            sessionStorage.setItem("fetchTagFailedReason", "无法获取货柜编号")
                            that.$router.go(-1)
                        } else {
                            that.boxTag = response.Tag
                        }
                    })
                } else {
                    sessionStorage.setItem("fetchTag", "failed")
                    sessionStorage.setItem("fetchTagFailedReason", "请扫描主控二维码")
                    this.$router.go(-1)
                }
            },
            ok() {
                this.$router.replace("/home")
            }
        }
    }
</script>

<style scoped>
    .note {
        margin-top: 20px;
        font-size: 20px;
        color: #666;
    }

    .bottom-button-area {
        width: 100%;
        position: absolute;
        bottom: 30px;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .button {
        width: 50%;
        background-color: #20273E;
        height: 40px;
        border-radius: 50px;
        color: white;
        font-size: 15px;
        border: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .box-tag {
        font-size: 80px;
        margin-top: 20px;
    }

    .box {
        width: 100%;
        height: 100%;
    }

    .qrcode-video {
        width: 100%;
        height: 50%;
        background-color: black;
    }
</style>
